import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const ServicePointIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="#E5E5E5"
      d="m105.554 27.776-2.006 2.9s-8.597 3.306-10.987 8.208c0 0-2.747 3.422 0 33.701l43.648 1.19-3.187-35.007s-1.043-9.34-6.757-10.615l-9.999-1.74z"
    />
    <path fill="#C9C9C9" d="m113.19 34.301.687 8.353 1.73-.348-.687-8.44z" />
    <path fill="#DEA07B" d="M105.526 24.527v3.162l8.351 6.496 2.801-7.657z" />
    <path
      fill="#C9C9C9"
      d="m92.067 67.25 4.532-.958a23 23 0 0 1-1.319-6.613c0-2.581-.439-7.309-.439-7.309a50.2 50.2 0 0 1 1.84-11.369c1.429-3.567 9.477-8.005 9.477-8.005l-2.747-2.32a37 37 0 0 0-7.471 4.206 8.7 8.7 0 0 0-3.05 3.112 9.3 9.3 0 0 0-1.235 4.283 142.3 142.3 0 0 0 .412 24.972"
    />
    <path fill="#8E8E8E" d="m105.526 27.689 8.351 6.496-2.198 3.48-8.158-7.134zM101.214 46.019l.11 19.46 2.005-.347" />
    <path
      fill="#F4F4F4"
      d="m118.382 26.818 7.444 1.19a8.1 8.1 0 0 1 3.253 1.708 8.65 8.65 0 0 1 2.241 3.019 28.5 28.5 0 0 1 2.197 11.601l-.934.406s-1.263-10.557-5.082-12.558a52.7 52.7 0 0 0-9.421-2.9z"
    />
    <path
      fill="#8E8E8E"
      d="m125.304 39.754 3.653 20.505-1.621.319M116.678 26.528l-2.802 7.657 3.132 1.77 1.373-9.137z"
    />
    <path
      fill="#F1BE96"
      d="M122.035 14.26c.549 7.135-3.159 13.167-9.037 13.515s-10.988-5.8-11.537-12.848 1.346-12.877 9.257-12.877 11.015 5.075 11.317 12.21"
    />
    <path
      fill="#28211E"
      d="M107.806 13.274c-1.456-.261-.302 4.873-1.208 5.569-.907.696-1.319-3.336-2.747-3.336-2.198 0-1.731 5.8-2.445-.406-.769-7.222 1.401-13.051 9.312-13.051a9.64 9.64 0 0 1 5.943 1.334c1.804 1.08 3.249 2.72 4.138 4.698.233.512.351 1.074.342 1.642a3.8 3.8 0 0 1-.389 1.63 3.6 3.6 0 0 1-1.039 1.272 3.36 3.36 0 0 1-1.469.648c-3.45.67-6.987.67-10.438 0"
    />
    <path
      fill="url(#dhl__illustrations_servicepointillustration_svg_a)"
      d="m93.77 158 22.277-4.641-37.797-19.838-22.25 4.67z"
      opacity={0.6}
    />
    <path fill="#FDDE84" d="m116.019 90.365 66.392-12.559-37.797-19.809L78.25 70.555z" />
    <path fill="#C39000" d="M116.019 90.365v62.995l-37.77-19.81V70.555z" />
    <path fill="#FCCE09" d="M116.019 90.364v62.995l66.392-12.558V77.806z" />
    <path fill="#996A0D" d="m115.388 89.118 69.358-13.11-39.472-20.737-69.359 13.138z" />
    <path fill="#634509" d="M115.388 89.118v3.973L75.915 72.383v-3.974z" />
    <path fill="#BC9361" d="M115.387 89.118v3.973l69.359-13.11v-3.973z" />
    <path
      fill="url(#dhl__illustrations_servicepointillustration_svg_b)"
      d="m109.784 87.928 11.097-2.32-13.102-6.932-11.098 2.32z"
      opacity={0.4}
    />
    <path fill="#FDDE84" d="m120.881 76.356 12.828-2.32-13.103-6.932-12.827 2.32z" />
    <path fill="#AA7B33" d="m115.662 73.63 12.828-2.32-3.131-1.654-12.856 2.32z" opacity={0.4} />
    <path fill="#C39000" d="M120.881 76.356v9.223l-13.102-6.932v-9.223z" />
    <path fill="#AA7B33" d="M115.662 73.63v4.292l-3.159-1.711v-4.235z" opacity={0.4} />
    <path fill="#FCCE09" d="M120.881 76.356v9.223l12.828-2.35v-9.193z" />
    <path fill="#fff" d="M122.639 78.357v5.685l9.285-1.682v-5.685z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m127.996 81.924 1.62-.29v-3.393l-1.62.29zM123.518 82.882l1.374-.261v-3.51l-1.374.261zM126.43 82.215h.687v-3.51h-.687zM131.045 77.98h-.687v3.393h.687zM125.661 82.36h.275v-3.452h-.275z"
      clipRule="evenodd"
    />
    <path
      fill="url(#dhl__illustrations_servicepointillustration_svg_c)"
      d="m137.939 75.718 7.994-1.682-13.57-7.106-7.993 1.653z"
      opacity={0.4}
    />
    <path fill="#FDDE84" d="m145.933 51.413 23.87-4.495-13.57-7.135-23.87 4.524z" />
    <path fill="#AA7B33" d="m140.109 48.339 23.843-4.496-2.252-1.189-23.898 4.496z" opacity={0.4} />
    <path fill="#C39000" d="M145.933 51.413v22.623l-13.57-7.106V44.307z" />
    <path fill="#AA7B33" d="M140.109 48.339v4.901l-2.307-1.247V47.15z" opacity={0.4} />
    <path fill="#FCCE09" d="M145.933 51.413v22.623l23.87-4.496V46.918z" />
    <path fill="#DEA07B" d="m117.228 18.553.879 3.422-1.428-.232" />
    <path
      fill="#D40511"
      d="m125.167 119.948 6.729-1.364-.357.61-6.372 1.276zM125.167 118.991l7.416-1.48-.357.581-7.059 1.421zM125.167 120.905l6.043-1.218-.357.58-5.686 1.131zM174.967 110.493l-6.702 1.334.357-.58 6.345-1.276zM174.967 111.421l-7.389 1.479.357-.58 7.032-1.392zM169.309 110.145l5.658-1.131v.522l-6.015 1.189zM131.704 120.093l3.186-5.076 3.956-.783c.439 0 .439 0 .22.435l-.797 1.276c0 .174-.302.493.357.377l5.384-1.073a7.3 7.3 0 0 1-1.912 2.122 6.9 6.9 0 0 1-2.538 1.185l-7.801 1.566zM149.998 114.031l-1.73 2.755-4.588.899 1.731-2.755zM156.591 112.697l-1.731 2.755-4.56.928 1.731-2.755zM158.102 112.407l-.495.783c-.577.899 0 1.74 1.813 1.363l7.334-1.479 1.731-2.755z"
    />
    <path
      fill="#D40511"
      d="m133.929 112.465-1.593 2.523 8.68-1.74c.439 0 .439 0 .22.435l-.797 1.276c0 .174-.302.493.357.377l3.544-.696 1.043-1.682c.66-1.044 0-2.9-2.28-2.32zM157.003 112.088l-11.18 2.233 3.049-4.843 4.56-.929-1.758 2.785 2.06-.406 1.731-2.785 4.587-.928zM166.369 106.084l-3.131 4.728-4.752 1.073 3.049-4.844z"
    />
    <path fill="#C9C9C9" d="m117.997 41.146.549 5.308 2.967.55 2.198-1.565-.55-5.28z" />
    <path
      fill="#8E8E8E"
      d="m123.244 41.117-.083-.957-5.164.986.082.957M114.701 35.897a.72.72 0 0 1-.151.429.66.66 0 0 1-.371.238.39.39 0 0 1-.378-.086.447.447 0 0 1-.144-.378.72.72 0 0 1 .151-.43.65.65 0 0 1 .371-.238.39.39 0 0 1 .377.086.4.4 0 0 1 .117.17.46.46 0 0 1 .028.209M114.921 38.449a.73.73 0 0 1-.151.43.66.66 0 0 1-.371.237.39.39 0 0 1-.378-.086.45.45 0 0 1-.144-.378.72.72 0 0 1 .151-.43.65.65 0 0 1 .371-.237.39.39 0 0 1 .377.086.4.4 0 0 1 .117.17.5.5 0 0 1 .028.208M115.168 41.117a.72.72 0 0 1-.151.43.66.66 0 0 1-.371.237.39.39 0 0 1-.378-.086.45.45 0 0 1-.144-.378.72.72 0 0 1 .151-.43.65.65 0 0 1 .371-.237.39.39 0 0 1 .377.086.4.4 0 0 1 .117.17.5.5 0 0 1 .028.208"
    />
    <path fill="#fff" d="M156.206 62.58v6.38l10.438-1.885v-6.41z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m162.222 66.582 1.84-.348v-3.8l-1.84.349zM157.195 67.51l1.538-.29v-3.8l-1.538.29zM160.491 66.9h.769v-3.944h-.769zM165.655 62.145h-.769v3.799h.769zM159.585 67.075h.302v-3.858h-.302z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_servicepointillustration_svg_a"
        x1={79.874}
        x2={86.436}
        y1={149.613}
        y2={136.349}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_servicepointillustration_svg_b"
        x1={106.303}
        x2={108.685}
        y1={84.758}
        y2={79.624}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_servicepointillustration_svg_c"
        x1={1166.94}
        x2={1170.66}
        y1={285.399}
        y2={267.473}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.21} stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
